import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BaseHeader from '@/components/BaseHeader.vue';
  import BaseFooter from '@/components/BaseFooter.vue';
  import AllPopups from '@/components/AllPopups.vue';
  // 引入useRouter
  import { useRouter } from "vue-router";
  import { useStore } from "vuex";
  import { key } from "../store";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'homeView',
  setup(__props) {

  let store = useStore(key);
  const router = useRouter();

  //更新菜单选中样式
  store.commit("changePage", router.currentRoute.value.meta.lv);

  // 路由守卫
  router.beforeEach((to, from, next) => {
    //更新菜单选中样式
    store.commit("changePage", to.meta.lv);
    // 移动端使用的title
    let middle = window.innerWidth < 1200 ? " | " : "-";
    let pro = window.innerWidth < 1200 && to.meta.lv === "2" ? "产品服务-" : "";
    //设置跳转路由后页面的标题
    document.title = "八爪教育" + middle + pro + to.meta.title as string;
    // 同页面
    if( to.name === from.name) { return }
    // 回到页面顶部
    window.scrollTo(0,0);
    // 跳转
    next();
  })
  
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AllPopups),
    _createVNode(BaseHeader),
    _createVNode(_component_router_view),
    _createVNode(BaseFooter)
  ], 64))
}
}

})